import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { useLocalStorage } from '../../services/hooks/useLocalStorage';

const useStyles = makeStyles({
    resultContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '400px',
        '& *': {
            margin: '12px'
        }
    },
    resultText: {
        maxWidth: '600px',
        textAlign: 'center'
    },
});

const Failure = () => {
    const classes = useStyles();
    const [stratus] = useLocalStorage("stratus", false);
    const ns = stratus ? 'stratus' : 'scantrip';
    const { t } = useTranslation(ns);

    return (
        <div className={classes.resultContainer}>
            <div className={classes.resultText}>{t('An error has occurred while processing your document. Please consult the workflow logs to determine the location and nature of the error.')}</div>
        </div>
    )
}

export default Failure;
